<template>
  <div>
    <div
      v-if="isLoading"
      class="position-fixed"
      style="top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 10"
    >
      <b-spinner label="読込中..."></b-spinner>
    </div>
    <UserList
      :provider="userListProvider"
      :totalRows="userTotal"
      @create="handleUserCreate"
      @edit="handleUserListEdit"
      @delete="handleUserListDelete"
      @csv="handleUserListCSV"
    >
      <template #create-button-label>修了生の登録</template>
    </UserList>
    <UserEditModal
      :data="userEditData"
      :validations="validations"
      isAdmin="0"
      @ok="handleUserEditModalOk"
      @cancel="handleUserEditModalCancel"
    ></UserEditModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UserList from '@/components/UserList.vue'
import UserEditModal from '@/components/UserEditModal.vue'

export default {
  name: 'Students',

  components: {
    UserList,
    UserEditModal
  },

  mounted() {
    // ビュー全体のレンダリング後に実行
    this.$nextTick(function () {})
  },

  data() {
    return {
      isLoading: false
    }
  },

  computed: {
    ...mapState({
      isLoggedIn: (state) => state.auth.isLoggedIn,
      validations: (state) => state.user.validations,
      userList: (state) => state.user.list,
      userTotal: (state) => state.user.total,
      userEditData: (state) => state.user.editData
    })
  },

  methods: {
    userListProvider(ctx, callback) {
      this.isLoading = true
      if (typeof window._debounceUserListProvider !== 'undefined') {
        clearTimeout(window._debounceUserListProvider)
      }
      // eslint-disable-next-line no-new
      new Promise((resolve) => {
        window._debounceUserListProvider = setTimeout(async () => {
          await this.$store.dispatch('user/getUsers', { adminStatus: 0, ctx })
          callback(this.userList)
          this.isLoading = false
        }, 400)
      })
      // eslint-disable-next-line standard/no-callback-literal
      callback([])
    },
    async handleUserCreate() {
      await this.$store.commit('user/setEditData', {})
      this.$bvModal.show('user-edit-modal')
    },
    async handleUserListEdit(data) {
      // テーブルが持っているデータをモーダルに注入
      await this.$store.commit('user/setEditData', data.item)
      this.$bvModal.show('user-edit-modal')
    },
    async handleUserEditModalOk(editData) {
      try {
        let message = '修了生を'
        // user/create or user/updateの分岐
        if ('id' in this.userEditData) {
          await this.$store.commit('user/setEditData', { ...this.userEditData, ...editData })
          await this.$store.dispatch('user/updateUser')
          message += '編集しました。'
        } else {
          await this.$store.commit('user/setEditData', { ...this.userEditData, ...editData, admin_status: 0 })
          await this.$store.dispatch('user/createUser')
          message += '登録しました。'
        }
        // バリデーションエラーの場合はモーダルを閉じない
        if (Object.keys(this.validations).length) {
          // console.log(Object.keys(this.validations))
        } else {
          this.$root.$bvToast.toast(message, {
            variant: 'success',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 3000
          })
          this.$bvModal.hide('user-edit-modal')
          this.$root.$emit('bv::refresh::table', 'user-list')
        }
      } catch (_) {}
    },
    handleUserEditModalCancel() {
      this.$bvModal.hide('user-edit-modal')
    },
    async handleUserListDelete(id) {
      try {
        await this.$store.dispatch('user/deleteUser', { id: id })
        this.$root.$bvToast.toast('修了生を削除しました。', {
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000
        })
        this.$root.$emit('bv::refresh::table', 'user-list')
      } catch (err) {
        const errorMessages = []
        for (const key in err) {
          errorMessages.push(`・${err[key]}`)
        }
        this.$root.$bvToast.toast(errorMessages.join('\n'), {
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          toastClass: 'pre-wrap',
          noAutoHide: true
        })
      }
    },
    handleUserListCSV() {
      this.$store.dispatch('user/downloadCSV', { adminStatus: 0 })
    }
  }
}
</script>
